/*
 * @Author: laishaojiang
 * @Date: 2021-09-13 19:41:59
 * @Description: 订单/地址等场景手机号脱敏展示，点击眼睛后拉取明文
 */
import util from 'lib/util'

export default {
  data() {
    return {
      isShowSendPhone: false,
      isShowRecPhone: false,
      sensitivePlaintextCache: {}
    }
  },

  computed: {
    sendPhoneSensitiveOpts() {
      return this.sensitivePhoneOpts('sendmobile')
    },
    recPhoneSensitiveOpts() {
      return this.sensitivePhoneOpts('recmobile')
    }
  },

  methods: {
    getOrderDetailContext() {
      return this.orderDetail || this.detail || this.order || this.orderDetailInfo || {}
    },

    getSensitiveCacheKey(opts) {
      const { cname, type, sid } = opts || {}
      if (!cname || !type || !sid) {
        return ''
      }
      return `${type}_${sid}_${cname}`
    },

    /** 订单等场景：组装敏感字段明文查询参数 */
    sensitivePhoneOpts(cname, options = {}) {
      const { type = 'order', sid, text } = options
      const detail = this.getOrderDetailContext()
      const businessId = sid || detail.expid || detail.expId || this.expid || this.expId
      let maskedText = text
      if (maskedText == null || maskedText === '') {
        if (cname === 'sendmobile') {
          maskedText = detail.sendmobile || detail.sendMobile || detail.sendPhone || detail.sendtel || detail.sendTel || ''
        } else {
          maskedText = detail.recmobile || detail.recMobile || detail.recPhone || detail.rectel || detail.recTel || ''
        }
      }
      if (!businessId || !maskedText) {
        return null
      }
      return {
        cname,
        text: maskedText,
        type,
        sid: String(businessId)
      }
    },

    /** 地址簿场景 */
    addressPhoneSensitiveOpts(contact) {
      if (!contact || !contact.id) {
        return null
      }
      const useTel = !contact.phone && contact.fixedPhone
      const cname = useTel ? 'tel' : 'mobile'
      const text = useTel ? contact.fixedPhone : contact.phone
      if (!text) {
        return null
      }
      return {
        cname,
        text,
        type: 'address',
        sid: String(contact.id)
      }
    },

    async fetchSensitivePlaintext(opts) {
      const cacheKey = this.getSensitiveCacheKey(opts)
      if (!cacheKey) {
        return ''
      }
      if (this.sensitivePlaintextCache[cacheKey]) {
        return this.sensitivePlaintextCache[cacheKey]
      }
      const { cname, text, type, sid } = opts
      const res = await this.$request('/perapi-system/sensitive/plaintext', {
        contentType: 'application/json',
        data: {
          cname,
          text,
          type,
          sid
        }
      })
      const payload = res.data
      const plaintext = typeof payload === 'string' ? payload : (payload?.text ?? payload?.plaintext ?? '')
      this.$set(this.sensitivePlaintextCache, cacheKey, plaintext)
      return plaintext
    },

    async togglePhone(flagKey, sensitiveOpts) {
      const isShow = this[flagKey]
      if (!isShow && sensitiveOpts?.cname && sensitiveOpts?.sid) {
        try {
          await this.fetchSensitivePlaintext(sensitiveOpts)
        } catch (e) {
          return
        }
      }
      this[flagKey] = !isShow
    },

    /** 地址编辑/选址：掩码号码换明文（编辑、下单回填） */
    async resolveAddressPlainPhone(detail) {
      if (!detail || !detail.id) {
        return detail
      }
      const result = { ...detail }
      const needPhone = result.phone && String(result.phone).indexOf('*') > -1
      const needTel = result.fixedPhone && String(result.fixedPhone).indexOf('*') > -1
      if (!needPhone && !needTel) {
        return result
      }
      try {
        if (needPhone) {
          result.phone = await this.fetchSensitivePlaintext({
            cname: 'mobile',
            text: result.phone,
            type: 'address',
            sid: String(result.id)
          })
        }
        if (needTel) {
          result.fixedPhone = await this.fetchSensitivePlaintext({
            cname: 'tel',
            text: result.fixedPhone,
            type: 'address',
            sid: String(result.id)
          })
        }
      } catch (e) {
        if (needPhone) {
          result.phone = ''
        }
        if (needTel) {
          result.fixedPhone = ''
        }
      }
      return result
    },

    /** 地址簿列表：按联系人切换手机号展示 */
    async toggleContactPhone(contact) {
      if (!contact) {
        return
      }
      const sensitiveOpts = this.addressPhoneSensitiveOpts(contact)
      if (!contact.isShowPhone && sensitiveOpts?.sid) {
        try {
          await this.fetchSensitivePlaintext(sensitiveOpts)
        } catch (e) {
          return
        }
      }
      contact.isShowPhone = !contact.isShowPhone
    },

    eyesSrc(val) {
      return val ? 'https://cdn.kuaidi100.com/images/rebuild/icon-open_lock.png' : 'https://cdn.kuaidi100.com/images/rebuild/icon-close_lock.png'
    },

    encryptionPhone(val, show, sensitiveOpts) {
      if (!val) {
        return val
      }
      if (!show) {
        if (/\*/.test(String(val))) {
          return val
        }
        return util.hidePhone(val)
      }
      const cacheKey = this.getSensitiveCacheKey(sensitiveOpts)
      if (cacheKey && this.sensitivePlaintextCache[cacheKey]) {
        return this.sensitivePlaintextCache[cacheKey]
      }
      return val
    }
  }
}
